import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login, loading } = useAuthStore();
  const [email, setEmail] = useState('admin@helpdeck.local');
  const [password, setPassword] = useState('123456789');
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(email, password, rememberMe);
    if (result.success) {
      navigate('/dashboard');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Helpdeck</h1>
        <p style={styles.subtitle}>IT Support System</p>
        
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onFocus={(e) => e.target.style.borderColor = '#1e3a8a'}
              onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
              placeholder="admin@helpdeck.local"
              style={styles.input}
              required
              tabIndex={1}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={(e) => e.target.style.borderColor = '#1e3a8a'}
              onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
              placeholder="••••••••••••••••"
              style={styles.input}
              required
              tabIndex={2}
            />
          </div>

          <div style={styles.checkboxGroup}>
            <input
              type="checkbox"
              id="rememberMe"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              style={styles.checkbox}
              tabIndex={3}
            />
            <label htmlFor="rememberMe" style={styles.checkboxLabel}>
              จดจำการล็อกอินสำหรับ 90 วัน
            </label>
          </div>

          <button
            type="submit"
            disabled={loading}
            onClick={handleSubmit}
            style={{
              ...styles.button,
              opacity: loading ? 0.6 : 1,
              cursor: loading ? 'not-allowed' : 'pointer',
            }}
            tabIndex={0}
          >
            {loading ? 'กำลังล็อกอิน...' : 'เข้าสู่ระบบ'}
          </button>
        </form>

        <div style={styles.demoInfo}>
          <p style={styles.demoTitle}>📋 Demo Accounts:</p>
          <div style={styles.demoItem}>
            <strong>Admin:</strong> admin@helpdeck.local / 123456789
          </div>
          <div style={styles.demoItem}>
            <strong>Agent:</strong> john@helpdeck.local / password123
          </div>
          <div style={styles.demoItem}>
            <strong>Agent:</strong> jane@helpdeck.local / password123
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(-45deg, #1e293b 0%, #0f172a 25%, #1a1f3a 50%, #2d1b69 75%, #0f172a 100%)',
    backgroundSize: '400% 400%',
    paddingTop: '2rem',
    paddingBottom: '6rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    pointerEvents: 'auto',
    position: 'relative',
    overflow: 'hidden',
  },
  card: {
    background: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(20px)',
    borderRadius: '20px',
    padding: '2.5rem',
    boxShadow: '0 20px 60px rgba(30, 58, 138, 0.25), 0 0 100px rgba(30, 58, 138, 0.15)',
    width: '100%',
    maxWidth: '420px',
    pointerEvents: 'auto',
    border: '1px solid rgba(255, 255, 255, 0.95)',
    position: 'relative',
    zIndex: 10,
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: '800',
    textAlign: 'center',
    marginBottom: '0.5rem',
    background: 'linear-gradient(135deg, #1e3a8a 0%, #0f2847 50%, #f97316 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
  subtitle: {
    fontSize: '0.95rem',
    color: '#64748b',
    textAlign: 'center',
    marginBottom: '2.5rem',
    fontWeight: '500',
    letterSpacing: '0.5px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    pointerEvents: 'auto',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.625rem',
    pointerEvents: 'auto',
  },
  label: {
    fontSize: '0.875rem',
    fontWeight: '700',
    color: '#1e293b',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  input: {
    padding: '1rem',
    border: '2px solid rgba(203, 213, 225, 0.5)',
    borderRadius: '12px',
    fontSize: '0.95rem',
    fontFamily: 'inherit',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    pointerEvents: 'auto',
    outline: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    zIndex: 10,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
  },
  'input:focus': {
    borderColor: '#1e3a8a',
    background: '#ffffff',
    boxShadow: '0 0 0 4px rgba(30, 58, 138, 0.15), 0 4px 12px rgba(30, 58, 138, 0.2)',
    transform: 'translateY(-2px)',
  },
  checkboxGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.625rem',
    pointerEvents: 'auto',
  },
  checkbox: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    pointerEvents: 'auto',
    accentColor: '#1e3a8a',
  },
  checkboxLabel: {
    fontSize: '0.875rem',
    cursor: 'pointer',
    color: '#1e293b',
    fontWeight: '600',
  },
  button: {
    padding: '1rem',
    background: 'linear-gradient(135deg, #1e3a8a 0%, #0f2847 50%, #1e3a8a 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontSize: '1rem',
    fontWeight: '800',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    pointerEvents: 'auto',
    userSelect: 'none',
    zIndex: 10,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    boxShadow: '0 10px 30px rgba(30, 58, 138, 0.35)',
  },
  'button:hover:not(:disabled)': {
    boxShadow: '0 15px 45px rgba(30, 58, 138, 0.45)',
    transform: 'translateY(-4px)',
  },
  'button:active:not(:disabled)': {
    transform: 'translateY(-2px)',
  },
  demoInfo: {
    marginTop: '2rem',
    padding: '1.5rem',
    background: 'linear-gradient(135deg, rgba(30, 58, 138, 0.08) 0%, rgba(249, 115, 22, 0.08) 100%)',
    borderRadius: '12px',
    border: '1px solid rgba(30, 58, 138, 0.25)',
    backdropFilter: 'blur(10px)',
  },
  demoTitle: {
    fontSize: '0.875rem',
    fontWeight: '800',
    color: '#1e3a8a',
    marginBottom: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  demoItem: {
    fontSize: '0.8rem',
    color: '#1e3a8a',
    marginBottom: '0.5rem',
    fontFamily: 'monospace',
    lineHeight: '1.6',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    padding: '0.5rem 0.75rem',
    borderRadius: '6px',
    borderLeft: '3px solid #f97316',
  },
};
